module.exports = __webpack_public_path__ + "images/166983fd843586a925e8d787e04766afd.svg";